/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Newpassword1Inputs */

const zh_auth_newpassword1 = /** @type {(inputs: Auth_Newpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新密码`)
};

const en_auth_newpassword1 = /** @type {(inputs: Auth_Newpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Password`)
};

const es_auth_newpassword1 = /** @type {(inputs: Auth_Newpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva contraseña`)
};

/**
* | output |
* | --- |
* | "New Password" |
*
* @param {Auth_Newpassword1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_newpassword1 = /** @type {((inputs?: Auth_Newpassword1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Newpassword1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_newpassword1(inputs)
	if (locale === "en") return en_auth_newpassword1(inputs)
	return es_auth_newpassword1(inputs)
});
export { auth_newpassword1 as "auth_newPassword" }